module.exports = __webpack_public_path__ + "static/img/8.1bfb1aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/8.png
// module id = 6IAk
// module chunks = 0